import React from 'react'
import { apiGet, apiPut, apiDelete } from '../utils/api'

export default function PlayerDiscounts() {
  const [items, setItems] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(false)
  const [players, setPlayers] = React.useState<any[]>([])
  const [tournaments, setTournaments] = React.useState<any[]>([])
  const [editing, setEditing] = React.useState<any | null>(null)
  const [editMode, setEditMode] = React.useState<'DISCOUNT' | 'SURCHARGE'>('DISCOUNT')
  const [editReason, setEditReason] = React.useState<string>('LOYALTY')
  const [editDate, setEditDate] = React.useState('')
  const [editLevel, setEditLevel] = React.useState('')
  const [editAmount, setEditAmount] = React.useState('')
  const [editComment, setEditComment] = React.useState('')

  const load = async () => {
    try {
      setLoading(true)
      const [data, dp, dt] = await Promise.all([
        apiGet<{ items?: any[] }>('/player-fee-corrections'),
        apiGet<{ players?: any[]; items?: any[] }>('/players?isActive=true&limit=1000'),
        apiGet<{ tournaments?: any[]; items?: any[] }>('/tournaments?limit=1000'),
      ])
      const arr = Array.isArray(data?.items) ? data.items : []
      setItems(arr)
      setPlayers(dp.players || dp.items || [])
      setTournaments(dt.tournaments || dt.items || [])
    } catch {}
    finally { setLoading(false) }
  }

  React.useEffect(() => { load() }, [])

  const tournamentName = (id?: string) => (tournaments || []).find((t:any)=>t.id===id)?.name || '-'
  const playerName = (id?: string) => (players || []).find((p:any)=>p.id===id)?.name || id

  const openEdit = (row: any) => {
    setEditing(row)
    setEditMode(row.correctionMode === 'SURCHARGE' ? 'SURCHARGE' : 'DISCOUNT')
    setEditReason((row.reason as any) || 'LOYALTY')
    setEditDate(String(row.createdAt || '').slice(0,10))
    setEditLevel(row.level || '')
    setEditAmount(String(row.amount || ''))
    setEditComment(row.comment || '')
  }

  const saveEdit = async () => {
    if (!editing) return
    try {
      const body: any = { reason: editReason }
      if (editDate) body.date = editDate
      if (editLevel) body.level = editLevel
      if (editAmount !== '') body.amount = Number(editAmount)
      body.comment = editComment
      body.correctionMode = editMode
      await apiPut(`/player-fee-corrections/${editing.id}`, body)
      setEditing(null)
      await load()
    } catch (err: any) {
      alert(err.message || 'Не удалось сохранить')
    }
  }

  const remove = async (id: string) => {
    if (!confirm('Удалить корректировку?')) return
    try {
      await apiDelete(`/player-fee-corrections/${id}`)
      await load()
    } catch (err: any) {
      alert(err.message || 'Не удалось удалить')
    }
  }

  return (
    <div className="space-y-4">
      <div className="text-lg font-semibold">Коррекции взносов игрокам</div>
      <div className="overflow-auto">
        <table className="min-w-full bg-white border rounded">
          <thead>
            <tr className="bg-gray-50 text-left text-sm text-gray-600">
              <th className="px-3 py-2 border-b">Дата</th>
              <th className="px-3 py-2 border-b">Игрок</th>
              <th className="px-3 py-2 border-b">Турнир</th>
              <th className="px-3 py-2 border-b">Уровень</th>
              <th className="px-3 py-2 border-b">Режим</th>
              <th className="px-3 py-2 border-b text-right">Сумма</th>
              <th className="px-3 py-2 border-b">Причина</th>
              <th className="px-3 py-2 border-b">Комментарий</th>
              <th className="px-3 py-2 border-b text-right">Действия</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {loading && (<tr><td className="px-3 py-3 text-gray-500" colSpan={7}>Загрузка...</td></tr>)}
            {!loading && items.length === 0 && (<tr><td className="px-3 py-3 text-gray-500" colSpan={7}>Нет данных</td></tr>)}
            {!loading && items.map((c:any) => (
              <tr key={c.id}>
                <td className="px-3 py-2 border-b whitespace-nowrap">{String(c.createdAt || '').slice(0,10)}</td>
                <td className="px-3 py-2 border-b">{playerName(c.playerId)}</td>
                <td className="px-3 py-2 border-b">{tournamentName(c.tournamentId)}</td>
                <td className="px-3 py-2 border-b">{c.level || '-'}</td>
                <td className="px-3 py-2 border-b">{c.correctionMode === 'SURCHARGE' ? 'Наценка' : 'Скидка'}</td>
                <td className="px-3 py-2 border-b text-right">{Number(c.amount||0).toFixed(2)}</td>
                <td className="px-3 py-2 border-b">{c.reason}</td>
                <td className="px-3 py-2 border-b">{c.comment || ''}</td>
                <td className="px-3 py-2 border-b text-right whitespace-nowrap">
                  <button className="px-2 py-1 border rounded mr-2" onClick={()=>openEdit(c)}>Редактировать</button>
                  <button className="px-2 py-1 border rounded" onClick={()=>remove(c.id)}>Удалить</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded shadow p-4">
            <div className="flex items-center justify-between mb-3">
              <div className="font-semibold">Правка скидки</div>
              <button className="px-3 py-1 border rounded" onClick={()=>setEditing(null)}>Закрыть</button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div>
                <label className="block text-xs text-gray-600 mb-1">Режим</label>
                <select className="border rounded px-3 py-2 w-full" value={editMode} onChange={e=>setEditMode(e.target.value as any)}>
                  <option value="DISCOUNT">Скидка</option>
                  <option value="SURCHARGE">Наценка</option>
                </select>
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Причина</label>
                <select className="border rounded px-3 py-2 w-full" value={editReason} onChange={e=>setEditReason(e.target.value as any)}>
                  {editMode === 'DISCOUNT' ? (
                    <>
                      <option value="LOYALTY">Лояльность</option>
                      <option value="MARKETING">Маркетинг</option>
                      <option value="ORGANIZER">Организатор</option>
                      <option value="SPONSOR">Спонсор</option>
                      <option value="PRIZE">Призовые</option>
                      <option value="LOTTERY">Лотерея</option>
                    </>
                  ) : (
                    <>
                      <option value="PENALTY">Штраф</option>
                      <option value="LATE_PAYMENT">Просрочка</option>
                      <option value="DISCIPLINE">Дисциплина</option>
                      <option value="MATCH_RESCHEDULE_EXTRA_COURT_RESERVE">Перенос матча и доп.резерв корта</option>
                      <option value="FIRST_MATCH_NO_SHOW_COURT_RESERVE">Неявка на первый матч и резерв корта</option>
                      <option value="OTHER">Другое</option>
                    </>
                  )}
                </select>
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Дата</label>
                <input type="date" className="border rounded px-3 py-2 w-full" value={editDate} onChange={e=>setEditDate(e.target.value)} />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Уровень</label>
                <input className="border rounded px-3 py-2 w-full" value={editLevel} onChange={e=>setEditLevel(e.target.value)} />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">Сумма, MDL</label>
                <input type="number" step="0.01" className="border rounded px-3 py-2 w-full" value={editAmount} onChange={e=>setEditAmount(e.target.value)} />
              </div>
              <div className="md:col-span-2">
                <label className="block text-xs text-gray-600 mb-1">Комментарий</label>
                <textarea className="border rounded px-3 py-2 w-full" rows={3} value={editComment} onChange={e=>setEditComment(e.target.value)} />
              </div>
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <button className="px-3 py-2 border rounded" onClick={()=>setEditing(null)}>Отмена</button>
              <button className="px-3 py-2 border rounded" onClick={saveEdit}>Сохранить</button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}


